import script from "./DivisionesMotovehiculoView.vue?vue&type=script&setup=true&lang=js"
export * from "./DivisionesMotovehiculoView.vue?vue&type=script&setup=true&lang=js"

import "./DivisionesMotovehiculoView.vue?vue&type=style&index=0&id=7de4b7cb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7de4b7cb"]])

export default __exports__